// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","logo":"logo-view_logo__1D-LM","image":"logo-view_image__5RUCO"};